export const state = {
  prescription: undefined,
  prescriptions: [],
  contenuPrescription: undefined,
  contenuPrescriptions: [],
  pagination: { size: 10 }
}